import {
  FETCH_PAYMENT_TOKEN_REQUEST,
  FETCH_PAYMENT_TOKEN_SUCCESS,
  FETCH_PAYMENT_TOKEN_FAILURE,
  MAKE_PAYMENT_REQUEST,
  MAKE_PAYMENT_SUCCESS,
  MAKE_PAYMENT_FAILURE,
  FETCH_PAYMENT_HISTORY_REQUEST,
  FETCH_PAYMENT_HISTORY_FAILURE,
  FETCH_PAYMENT_HISTORY_SUCCESS,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_FAILURE,
  DELETE_CARD_REQUEST,
} from "../constants";

const INITIAL_STATE = {
  isLoading: false,
  paymentToken: "",
  paymentHistory: [],
};

const paymentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        paymentToken: "",
      };
    case FETCH_PAYMENT_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentToken: action.payload,
      };
    case FETCH_PAYMENT_TOKEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        paymentToken: "",
      };

    case MAKE_PAYMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_CARD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case MAKE_PAYMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case DELETE_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case DELETE_CARD_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case FETCH_PAYMENT_HISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
        paymentHistory: [],
      };
    case FETCH_PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentHistory: action.payload,
      };
    case FETCH_PAYMENT_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        paymentHistory: [],
      };

    default:
      return state;
  }
};

export default paymentsReducer;
